// Fernand support widget. index.html installs a queueing stub for window.Fernand
// before client.js loads, so these calls are safe at any time; they just queue.
//
// The home tab mirrors the Intercom messenger it replaced: nothing for
// visitors, and for logged-in users the conversation card and the "schedule
// a demo" link (set in index.html), no article list. Leaving "articles" out
// of the tabs is what keeps that list off the home tab; the help centre is
// still linked from the profile menu.
//
// Live chat is only offered inside the 2.0 org area, any path containing
// "/org/". Elsewhere the widget opens on the email contact form, with the
// help articles beside it; the home tab is left out there, since its "ask a
// question" card starts a chat. Support buttons open the form, not a chat.

const CHAT_PATH = /\/org\//;
const WITH_CHAT = { tabs: ["home", "chat"], defaultTab: "home" };
const EMAIL_ONLY = { tabs: ["articles", "contact"], defaultTab: "contact" };

export function chatEnabledFor(pathname) {
  return CHAT_PATH.test(pathname || "");
}

export function tabsFor(pathname) {
  return chatEnabledFor(pathname) ? WITH_CHAT : EMAIL_ONLY;
}

function currentPath() {
  return typeof window === "undefined" ? "" : window.location.pathname;
}

function fernand(...args) {
  if (typeof window === "undefined" || typeof window.Fernand !== "function") return false;
  window.Fernand(...args);
  return true;
}

// Intercom greeted with "Hi <first name> 👋 / How can we help?".
export function greetingFor(name) {
  const first = (name || "").trim().split(/\s+/)[0];
  return first ? `Hi ${first} 👋 How can we help?` : "Hi 👋 How can we help?";
}

// `fernandData` is the `fernand` key from users/me: the lowercased email and
// its HMAC, signed on the server so a page cannot claim another user's identity.
// The email must be sent exactly as signed, so it comes from the API, not the form.
export function identifyUser(user, fernandData) {
  if (!fernandData?.hash || !fernandData?.email) return false;
  fernand("set", {
    user: {
      name: user?.name || "",
      email: fernandData.email,
      hash: fernandData.hash,
    },
    ...tabsFor(currentPath()),
    orgDescription: greetingFor(user?.name),
  });
  return fernand("show");
}

// Re-applies the tab policy for the current page. The org layout calls this
// when it unmounts, since the widget outlives client-side navigation.
export function applyTabPolicy() {
  return fernand("set", tabsFor(currentPath()));
}

// Opens the chat where chat is offered, the email form elsewhere. Returns
// false when the widget is not on the page so callers can fall back to a
// mailto link.
export function openSupport() {
  return fernand("open", chatEnabledFor(currentPath()) ? "chat" : "contact");
}

// Forget the user on logout so the next person on this browser does not see
// their conversations.
export function clearUser() {
  fernand("clear");
  fernand("hide");
}
